import { NavLink, useNavigate } from 'react-router-dom';
import { UserRound } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';
import { navLinks } from './navLinks';
import { QuickAdd } from './QuickAdd';

interface NavProps {
  onProfileClick: () => void;
}

export function Nav({ onProfileClick }: NavProps) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  return (
    <nav className="nav">
      {navLinks.map((l) => (
        <NavLink
          key={l.to}
          to={l.to}
          end={l.end}
          className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
        >
          {l.label}
        </NavLink>
      ))}

      {!loading && !user && (
        <div id="guest-nav">
          <button className="btn-glow" onClick={() => navigate('/login')}>
            Log in
          </button>
        </div>
      )}

      {!loading && user && (
        <div id="auth-nav">
          <QuickAdd />
          <button className="btn-profile" onClick={onProfileClick}>
            <UserRound size={16} strokeWidth={2} />
            Profile
          </button>
        </div>
      )}
    </nav>
  );
}
